import React, { useEffect } from 'react';
import { useState, Downgraded } from '@hookstate/core';
import {
    Box,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Divider,
    TextField,
    InputAdornment,
    Chip

} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import Helper from '../../../utility/helper';
import ButtonContainer from '../../../sharedcomponents/buttoncontainer/buttonContainer';
import StyledTableCell from '../../../sharedcomponents/styledTable/styledTableCell';
import StyledTableRow from '../../../sharedcomponents/styledTable/styledTableRow';
import UserModPermission from '../ModulePermission/userModPermission';
import ApiHelper from '../../../utility/ApiHelper';
import APIURLConstants from '../../../config/config';

const UserModuleList = (props) => {
    const columnsData = useState(null);
    const rowsData = useState(null);
    const disableButton = useState(true);
    const showLoading = useState(false);
    const [search, setSearch] = React.useState('');
    const filterRowsData = useState(null);
    useEffect(() => {
        if (props.data && columnsData.get() == null && rowsData.get() == null) {

            const { columns, rows } = props.data;
            if (columns.length > 0 && rows.length > 0) {
                let newRows = setRowAllModulePermission(rows);
                rowsData.set(JSON.parse(JSON.stringify(newRows)));
                filterRowsData.set(JSON.parse(JSON.stringify(newRows)));
                let newColumns = setAllHeaderPermission(columns, newRows);
                columnsData.set(JSON.parse(JSON.stringify(newColumns)));
            }
        }
    }, [props]);

    const handleSearchChange = (event) => {
        let str = event.target.value;
        const value = str.replace(/^\s+/g, '');
        setSearch(value);
        if (value.length > 0) {
            let modifyList = [];
            let newFilterRowsData = [...filterRowsData.attach(Downgraded).get()];
            newFilterRowsData.map((row) => {
                let keys = Object.keys(row);
                keys.map((key) => {
                    if (key == 'userName' || key == 'role' || key == 'tags') {
                        if (
                            typeof row[key].label === 'string' &&
                            row[key].label.toLowerCase().indexOf(value.toLowerCase()) > -1
                        ) {
                            if (modifyList.indexOf(row) == -1)
                                modifyList.push(row);
                        }
                    }
                })
            });
            filterRowsData.set(modifyList);
        }
        else {
            handleCancel();
        }
    }

    const handleClick = (e) => {
        let userPermission = [];
        const eventInfo = Helper.getStorage('eventInfo');
        const userInfo = Helper.getStorage('userInfo');
        e.preventDefault();
        if (filterRowsData.get() && filterRowsData.get().length > 0) {
            let newFilterRowsData = [...filterRowsData.attach(Downgraded).get()];
            let oldRowsData = [...rowsData.attach(Downgraded).get()];
            // let newMerge = [...newFilterRowsData, ...oldRowsData];
            // let map = new Map();
            // newMerge.forEach(item => {
            //     if (!map.has(item.userName.userID)) {
            //         map.set(item.userName.userID, item);
            //     }
            // });
            // let newRowsData = Array.from(map.values());

            var newRowsData = newFilterRowsData.filter(function (p, idx) {
                return JSON.stringify(p) !== JSON.stringify(oldRowsData[idx]);
            });

            if (newRowsData && newRowsData.length > 0) {
                newRowsData.map(row => {
                    let keys = Object.keys(row);
                    let obj = {};
                    let userName = row.userName;
                    let oldRecord
                    if (userName && userName.userID) {
                        obj['userID'] = userName.userID;
                        oldRecord = oldRowsData.find(i => i.userName && i.userName.userID === userName.userID);
                    }
                    keys.forEach(key => {
                        if (key != 'allModules' && key != 'role' && key != 'userName' && key != 'tags') {
                            //check if permission is changed for module then only add
                            if (!oldRecord || (oldRecord && JSON.stringify(oldRecord[key]) !== JSON.stringify(row[key]))) {
                                obj['eventID'] = eventInfo.eventID;
                                obj['onBehalfOf'] = 0;
                                obj['isAdmin'] = 1;
                                obj['moduleID'] = row[key]['moduleID'];
                                obj['permissionTypeID'] = row[key].permission == null ? 0 : row[key].permission;
                                obj['createdBy'] = userInfo.userID;
                                userPermission.push(obj);
                                obj = {
                                    ...obj,
                                    eventID: 0,
                                    onBehalfOf: 0,
                                    moduleID: 0,
                                    permissionTypeID: 0,
                                    createdBy: 0,
                                }
                            }
                        }
                    });

                });
            }
        }

        if (userPermission && userPermission.length > 0) {
            showLoading.set(true);
            disableButton.set(true);
            ApiHelper.post(APIURLConstants.POST_USER_MODULE_PERMISSIONS, userPermission)
                .then(res => {
                    if (res.data) {
                        props.setSnackBarProps({
                            ...props.snackBarProps,
                            openSnack: true,
                            variant: 'success',
                            message: 'Permissions updated successfully',
                        });
                        setSearch('');
                        rowsData.set(null);
                        columnsData.set(null);
                        filterRowsData.set(null);
                        props.getAllData();
                        showLoading.set(false);
                    }
                })
                .catch(err => {
                    if (err) {
                        console.log('err : ', err);
                        props.setSnackBarProps({
                            ...props.snackBarProps,
                            openSnack: true,
                            variant: 'error',
                            message: 'Error in permission updates',
                        });
                        showLoading.set(false);
                    }
                });

        }
    }

    const handleCancel = () => {
        const { columns, rows } = props.data;
        if (columns.length > 0 && rows.length > 0) {
            columnsData.set(JSON.parse(JSON.stringify(columns)));
            rowsData.set(JSON.parse(JSON.stringify(rows)));
            filterRowsData.set(JSON.parse(JSON.stringify(rows)));
            disableButton.set(true);
        }
    };
    const setAllHeaderPermission = (columns, rows) => {
        columns.map(column => {

            if (column.id != 'userName' && column.id != 'role' && column.id != 'tags') {
                let totalRows = 0;
                let perm0 = 0;
                let perm1 = 0;
                let perm2 = 0;
                rows.forEach(row => {
                    let keys = Object.keys(row);
                    keys.forEach((key) => {
                        if (key == column.id) {
                            if (row[key]['permission'] == 0) perm0++;
                            else if (row[key]['permission'] == 1) perm1++;
                            else if (row[key]['permission'] == 2) perm2++;
                            totalRows++;
                        }
                    });

                });
                if (totalRows > 0 && totalRows == perm0) {
                    column.permission = 0;
                } else if (totalRows > 0 && totalRows == perm1) {
                    column.permission = 1;
                }
                else if (totalRows > 0 && totalRows == perm2) {
                    column.permission = 2;
                }
                else {
                    column.permission = null;
                }
            }
        });
        return columns;
    }

    const setColumnHeaderPermission = (column, colIndex) => {
        column.permission = null;
        let newRowsData = [...filterRowsData.attach(Downgraded).get()];
        let totalRows = 0;
        let perm0 = 0;
        let perm1 = 0;
        let perm2 = 0;
        newRowsData.map((row) => {
            let keys = Object.keys(row);
            keys.map((key) => {
                if (key == column.id) {
                    if (row[key]['permission'] == 0) perm0++;
                    else if (row[key]['permission'] == 1) perm1++;
                    else if (row[key]['permission'] == 2) perm2++;
                    totalRows++;
                }
            });
        });
        if (totalRows > 0 && totalRows == perm0) {
            column.permission = 0;
        } else if (totalRows > 0 && totalRows == perm1) {
            column.permission = 1;
        }
        if (totalRows > 0 && totalRows == perm2) {
            column.permission = 2;
        }
        let newColumnsData = [...columnsData.attach(Downgraded).get()];

        if (column.permission == null) {
            const fIndex = newColumnsData.findIndex((col) => col.id == 'allModules');
            newColumnsData[fIndex].permission = null;
            const newColumn = { ...newColumnsData[fIndex] };
            columnsData[fIndex].set(newColumn);
        }
        columnsData[colIndex].set(column);
        setTimeout(() => {
            let newRowsData = [...filterRowsData.attach(Downgraded).get()];
            let newColumnsData = [...columnsData.attach(Downgraded).get()];
            let newColumns = setAllHeaderPermission(newColumnsData, newRowsData);
            columnsData.set(newColumns);
        }, 100);
    };

    // const setUserPermission = (rowIndex, colIndex, column, permission) => {
    //     let newRowsData = [...filterRowsData.attach(Downgraded).get()];
    //     // let newColumnsData = [...columnsData.attach(Downgraded).get()];
    //     let row = newRowsData[rowIndex];
    //     if (column.id == 'allModules') {
    //         let keys = Object.keys(row);
    //         keys.map((key) => {
    //             if (key != 'userName' && key != 'role' && key != 'tags') {
    //                 row[key]['permission'] = permission;
    //             }
    //         });
    //         filterRowsData[rowIndex].set(row);
    //         setColumnHeaderPermission(column, colIndex);
    //     }
    //     else if (column.id != 'userName' && column.id != 'role' && column.id != 'tags') {
    //         row[column.id]['permission'] = permission;
    //         row['allModules']['permission'] = null;

    //         // logic to set all modules permission if all other modules are set to same permission for user
    //         let keys = Object.keys(row);
    //         let perm0 = 0;
    //         let perm1 = 0;
    //         let perm2 = 0;
    //         let moduleCount = 0;
    //         keys.map((key) => {
    //             if (key != 'userName' && key != 'role' && key != 'allModules' && key != 'tags') {
    //                 if (row[key]['permission'] == 0) perm0++;
    //                 else if (row[key]['permission'] == 1) perm1++;
    //                 else if (row[key]['permission'] == 2) perm2++;
    //                 moduleCount++;
    //             }
    //         });
    //         if (moduleCount > 0 && moduleCount == perm0) {
    //             row['allModules']['permission'] = 0;
    //         }
    //         else if (moduleCount > 0 && moduleCount == perm1) {
    //             row['allModules']['permission'] = 1;
    //         }
    //         else if (moduleCount > 0 && moduleCount == perm2) {
    //             row['allModules']['permission'] = 2;
    //         }

    //         filterRowsData[rowIndex].set(JSON.parse(JSON.stringify(row)));
    //         // set column header permission as per all rows permission in the same column
    //         setColumnHeaderPermission(column, colIndex);
    //     }
    // };
    const setUserPermission = (rowIndex, colIndex, column, access) => {
        let newRowsData = [...filterRowsData.attach(Downgraded).get()];
        // let newColumnsData = [...columnsData.attach(Downgraded).get()];

        let permission = access;

        let row = newRowsData[rowIndex];

        if (column.id == 'allModules') {
            if (row['allModules']['permission'] === 2) {
                permission = 0;
            } else {
                permission = 2;
            }
            let keys = Object.keys(row);
            keys.map((key) => {
                if (key != 'userName' && key != 'role' && key != 'tags') {
                    // console.log(row[key]['permission']);
                    row[key]['permission'] = permission;
                }
            });
            filterRowsData[rowIndex].set(row);
            handleSaveDisable();
            setColumnHeaderPermission(column, colIndex);
        } else if (
            column.id != 'userName' &&
            column.id != 'role' &&
            column.id != 'tags'
        ) {
            // console.log(row[column.id]['permission']);
            row[column.id]['permission'] =
                row[column.id]['permission'] === 2 ? 0 : 2;
            row['allModules']['permission'] = null;

            // logic to set all modules permission if all other modules are set to same permission for user
            let keys = Object.keys(row);
            let perm0 = 0;
            let perm1 = 0;
            let perm2 = 0;
            let moduleCount = 0;
            keys.map((key) => {
                if (
                    key != 'userName' &&
                    key != 'role' &&
                    key != 'allModules' &&
                    key != 'tags'
                ) {
                    if (row[key]['permission'] == 0) perm0++;
                    else if (row[key]['permission'] == 1) perm1++;
                    else if (row[key]['permission'] == 2) perm2++;
                    moduleCount++;
                }
            });
            if (moduleCount > 0 && moduleCount == perm0) {
                row['allModules']['permission'] = 0;
            } else if (moduleCount > 0 && moduleCount == perm1) {
                row['allModules']['permission'] = 1;
            } else if (moduleCount > 0 && moduleCount == perm2) {
                row['allModules']['permission'] = 2;
            }

            filterRowsData[rowIndex].set(JSON.parse(JSON.stringify(row)));
            handleSaveDisable();
            // set column header permission as per all rows permission in the same column
            setColumnHeaderPermission(column, colIndex);
        }
    };
    const setHeaderPermission = (newColumnsData) => {
        let perm0 = 0;
        let perm1 = 0;
        let perm2 = 0;
        let moduleCount = 0;
        let fIndex = newColumnsData.findIndex((col) => col.id == 'allModules');
        newColumnsData.map((col) => {
            if (
                col.id != 'userName' &&
                col.id != 'role' &&
                col.id != 'allModules' &&
                col.id != 'tags'
            ) {
                if (col['permission'] == 0) perm0++;
                else if (col['permission'] == 1) perm1++;
                else if (col['permission'] == 2) perm2++;
                moduleCount++;
            }
        });
        if (fIndex > -1) {
            if (moduleCount > 0 && moduleCount == perm0) {
                newColumnsData[fIndex].permission = 0;
            } else if (moduleCount > 0 && moduleCount == perm1) {
                newColumnsData[fIndex].permission = 1;
            }
            if (moduleCount > 0 && moduleCount == perm2) {
                newColumnsData[fIndex].permission = 2;
            }
        }
        return newColumnsData;
    };

    const setRowAllModulePermission = (newRowsData) => {
        newRowsData.map((row) => {
            row['allModules']['permission'] = null;
            let perm0 = 0;
            let perm1 = 0;
            let perm2 = 0;
            let moduleCount = 0;
            let keys = Object.keys(row);
            keys.map((key) => {
                if (key != 'userName' && key != 'role' && key != 'allModules' && key != 'tags') {
                    if (row[key]['permission'] == 0) perm0++;
                    else if (row[key]['permission'] == 1) perm1++;
                    else if (row[key]['permission'] == 2) perm2++;
                    moduleCount++;
                }
            });
            if (moduleCount > 0 && moduleCount == perm0) {
                row['allModules']['permission'] = 0;
            } else if (moduleCount > 0 && moduleCount == perm1) {
                row['allModules']['permission'] = 1;
            } else if (moduleCount > 0 && moduleCount == perm2) {
                row['allModules']['permission'] = 2;
            }
        });
        return newRowsData;
    };

    const setUserHeadPermission = (colIndex, column, permission) => {
        let newRowsData = [...filterRowsData.attach(Downgraded).get()];
        let newColumnsData = [...columnsData.attach(Downgraded).get()];
        if (column && column.id == 'allModules') {
            console.log("into if", colIndex, column, permission);

            newColumnsData.map((colData) => {
                if (colData.id != 'userName' && colData.id != 'role' && colData.id != 'tags') {
                    colData.permission = permission;
                }
            });
            newRowsData.map((row) => {
                let keys = Object.keys(row);
                keys.map((key) => {
                    if (key != 'userName' && key != 'role' && key != 'tags') {
                        row[key].permission = permission;
                    }
                });
            });
        } else {
            if (newColumnsData[colIndex].permission === 2) {
                permission = 0;
            } else {
                permission = 2;
            }

            newColumnsData[colIndex].permission = permission;
            newRowsData.map((row) => {
                let keys = Object.keys(row);
                keys.map((key) => {
                    if (key == column.id) {
                        row[key].permission = permission;
                    }
                });
            });

            let fIndex = newColumnsData.findIndex(
                (col) => col.id == 'allModules'
            );
            if (fIndex > -1) {
                newColumnsData[fIndex].permission = null;
            }
            // check all modules permission
            newColumnsData = setHeaderPermission(newColumnsData);
            newRowsData = setRowAllModulePermission(newRowsData);
        }
        columnsData.set(newColumnsData);
        //rowsData.set(newRowsData);
        filterRowsData.set(newRowsData);
        handleSaveDisable();
    };

    const handleSaveDisable = () => {
        if (filterRowsData.get() && filterRowsData.get().length > 0) {
            let newFilterRowsData = [...filterRowsData.attach(Downgraded).get()];
            let oldRowsData = [...rowsData.attach(Downgraded).get()];
            var hasDataChanged = newFilterRowsData.some(function (p, idx) {
                return JSON.stringify(p) !== JSON.stringify(oldRowsData[idx]);
            });
            if (hasDataChanged) {
                disableButton.set(false);
            }
            else {
                disableButton.set(true);
            }
        }
        else {
            disableButton.set(true);
        }
    }
    return (
        // <Paper sx={{ width: '100%', overflow: 'hidden' }}>
        <>
            {columnsData.get() && filterRowsData.get() ? (
                <>
                    <Box sx={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', minHeight: '56px', mb: 1.5, width: '100%' }}>
                        <Box>
                            <TextField
                                id="search"
                                size="small"
                                label={'Search'}
                                value={search}
                                onChange={handleSearchChange}
                                autoComplete='off'
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <SearchIcon />
                                        </InputAdornment>
                                    ),
                                }}
                                sx={{
                                    // m: 1,
                                    maxWidth: { xs: '180px', md: '90%' }
                                }}
                            />
                        </Box>
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                            }}
                            item>
                            <ButtonContainer
                                handleClick={handleClick}
                                handleCancel={handleCancel}
                                showLoading={showLoading.get()}
                                loading={showLoading.get()}
                                buttonText={'Save'}
                                cancelText={'Reset'}
                                disableButton={disableButton.get()}
                                disableCancel={false}
                            />
                        </Box>
                    </Box>
                    <Box
                        component="form"
                        sx={{
                            // p: 2,
                            width: '100%',
                        }}
                        autoComplete="off"
                        onSubmit={handleClick}>
                        <TableContainer component={Paper} sx={{ overflow: 'auto', maxHeight: '100vh' }}>
                            <Table>
                                <TableHead>
                                    <TableRow size="small" style={{ position: 'sticky', top: 0, backgroundColor: '#f5f5f5' }}>
                                        {columnsData
                                            .attach(Downgraded)
                                            .get()
                                            .map((column, index) => (
                                                <StyledTableCell
                                                    key={`column_${index}`}
                                                    align={column.align}
                                                    size="small">
                                                    <Box
                                                        display="flex"
                                                        flexDirection="column"
                                                        alignItems={column.align == 'left' ? 'flex-start' : 'center'}>
                                                        <Typography
                                                            variant="h4"
                                                            flexGrow={1}
                                                            fontSize={12}
                                                            fontWeight={500}
                                                            color="primary">
                                                            {column.label === "DraftHotel" ? "PlayerHotel" : column.label}
                                                        </Typography>
                                                        {column.showPermission ? (
                                                            <UserModPermission
                                                                header={true}
                                                                column={column}
                                                                colIndex={index}
                                                                setUserHeadPermission={
                                                                    setUserHeadPermission
                                                                }
                                                            />
                                                        ) : null}
                                                    </Box>
                                                </StyledTableCell>
                                            ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {filterRowsData.get()
                                        ? filterRowsData
                                            .attach(Downgraded)
                                            .get()
                                            .map((row, rowIndex) => {

                                                return (
                                                    <StyledTableRow
                                                        key={`row_${rowIndex}`}
                                                        hover
                                                        tabIndex={-1}>
                                                        {columnsData
                                                            .attach(
                                                                Downgraded
                                                            )
                                                            .get()
                                                            .map(
                                                                (
                                                                    column,
                                                                    colIndex
                                                                ) => {

                                                                    const value =
                                                                        row[
                                                                        column
                                                                            .id
                                                                        ];
                                                                    return (
                                                                        <TableCell
                                                                            key={`row_column_${colIndex}`}
                                                                            align={value && value.align}
                                                                            size="small">
                                                                            <Box
                                                                                display="flex"
                                                                                flexDirection="column"
                                                                                alignItems={value && value.align == 'left' ? 'flex-start' : 'center'}>
                                                                                {value && value.showLabel ? (
                                                                                    <Typography
                                                                                        variant="h4"
                                                                                        flexGrow={
                                                                                            1
                                                                                        }
                                                                                        fontSize={
                                                                                            14
                                                                                        }
                                                                                        fontWeight={
                                                                                            400
                                                                                        }>
                                                                                        {
                                                                                            column.id === 'userName' ?
                                                                                                value.label.search('DELETED') !== -1 ? <><span style={{ color: 'red' }}>{`DELETED`}</span> <span>{value.label.replace('DELETED', '')}</span></> : value.label.replace('DELETED', '') : value.label
                                                                                        }
                                                                                    </Typography>
                                                                                ) : null}
                                                                                {value && value.showPermission ? (
                                                                                    <UserModPermission
                                                                                        value={
                                                                                            value
                                                                                        }
                                                                                        header={
                                                                                            false
                                                                                        }
                                                                                        column={
                                                                                            column
                                                                                        }
                                                                                        colIndex={
                                                                                            colIndex
                                                                                        }
                                                                                        row={
                                                                                            row
                                                                                        }
                                                                                        rowIndex={
                                                                                            rowIndex
                                                                                        }
                                                                                        setUserPermission={
                                                                                            setUserPermission
                                                                                        }
                                                                                    />
                                                                                ) : null}
                                                                                {value && value.showChips ?
                                                                                    (
                                                                                        value.label ? (
                                                                                            value.label.split(', ').map((chipItem) => {
                                                                                                return chipItem !== "" && (
                                                                                                    <Chip
                                                                                                        key={chipItem}
                                                                                                        label={chipItem}
                                                                                                        sx={{ mr: '4px', mb: "2px", '& .MuiChip-label': { maxWidth: '30ch' } }}
                                                                                                    />
                                                                                                );
                                                                                            })) : null
                                                                                    )
                                                                                    : null
                                                                                }
                                                                            </Box>
                                                                        </TableCell>
                                                                    );
                                                                }
                                                            )}
                                                    </StyledTableRow>
                                                );
                                            })
                                        : null}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </>
            ) : null}
        </>
        // </Paper>
    );
};
export default UserModuleList;
